(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ufe-rental-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ufe-home]');
    if (!root) return;
    const filters = root.querySelectorAll('[data-ufe-filter]');
    const cards = root.querySelectorAll('[data-ufe-product]');
    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        filters.forEach((item) => item.classList.remove('is-active'));
        filter.classList.add('is-active');
        const selected = filter.dataset.ufeFilter;
        cards.forEach((card) => {
          const kind = card.dataset.ufeKind || '';
          card.hidden = selected !== 'all' && !kind.includes(selected);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ufe-rental-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ufe-product-page]');
    if (!root) return;
    const hiddenVariant = root.querySelector('[data-ufe-variant-id]');
    const price = root.querySelector('[data-ufe-price]');
    const bookButton = root.querySelector('[data-ufe-book]');
    const bookLabel = root.querySelector('[data-ufe-book-label]');
    const availableLabel = root.dataset.bookLabel;
    const unavailableLabel = root.dataset.unavailableLabel;
    const variantPrices = new Map();

    root.querySelectorAll('[data-ufe-variant]').forEach((input) => {
      variantPrices.set((input.dataset.variantTitle || '').trim().toLowerCase(), input.dataset.price);
      input.addEventListener('change', () => {
        if (!input.checked) return;
        hiddenVariant.value = input.value;
        price.textContent = input.dataset.price;
        const available = input.dataset.available === 'true';
        bookButton.disabled = !available;
        bookLabel.textContent = available ? availableLabel : unavailableLabel;
      });
    });

    const updatePrice = (durationTitle) => {
      const selectedPrice = variantPrices.get(durationTitle.trim().toLowerCase());
      if (selectedPrice) price.textContent = selectedPrice;
    };

    const connectBookingWidget = () => {
      const frame = document.querySelector('#bta-product-widget iframe[title="widget_xcomponent"]');
      if (!frame || frame.dataset.ufePriceConnected === 'true') return false;
      const bindFrame = () => {
        try {
          const frameBody = frame.contentDocument && frame.contentDocument.body;
          if (!frameBody) return false;
          if (frameBody.dataset.ufePriceConnected === 'true') return true;
          frameBody.dataset.ufePriceConnected = 'true';
          frameBody.addEventListener('click', (event) => {
            const button = event.target && event.target.closest ? event.target.closest('button') : null;
            if (!button) return;
            updatePrice(button.textContent || '');
          }, true);
          return true;
        } catch (error) {
          return false;
        }
      };
      frame.addEventListener('load', bindFrame);
      if (bindFrame()) {
        frame.dataset.ufePriceConnected = 'true';
        return true;
      }
      return false;
    };

    let bookingWidgetChecks = 0;
    const bookingWidgetTimer = window.setInterval(() => {
      bookingWidgetChecks += 1;
      if (connectBookingWidget() || bookingWidgetChecks >= 80) {
        window.clearInterval(bookingWidgetTimer);
      }
    }, 250);

    const mainImage = root.querySelector('.ufe-gallery__main-image');
    root.querySelectorAll('[data-ufe-image]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        root.querySelectorAll('[data-ufe-image]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        mainImage.removeAttribute('srcset');
        mainImage.src = thumb.dataset.ufeImage;
      });
    });
    const dateInput = root.querySelector('[data-ufe-start-date]');
    if (dateInput) dateInput.min = new Date().toISOString().split('T')[0];
  })();

  } catch(e) { console.error(e); }
})();
})();
